// @ts-nocheck
import { IconButton, DialogContent } from '@mui/material';
import { Close } from '@mui/icons-material';
import * as React from 'react';
import HlxButton from "../../commonComponents/button/button";
import { StyledDialogActions, StyledDialogTitle, StyledGeneralDialog } from './generalDialog.style';
import { IGeneralDialogProps } from './generalDialog.types';
import { Button } from 'component/MarketPlace/ButtonComponents';
import Typography from 'component/MarketPlace/Typography/Typography';

const generalDialog = ({
	title = "Confirmation",
	content,
	headerDefault,
	buttonSubmit,
	hideButtonCancel,
	classname,
	fullWidth,
	maxWidth,
	handleClose,
	isOpen,
	disableBackdropClick,
	cancelLabel,
	headerBackgroundDefault,
	justifyContentTitle,
	justifyContentAction,
	hideCloseIcon = false,
	commonStyles,
	actionStyles,
	isMarketPlaceContent
}: IGeneralDialogProps) => {

	//Remove those two divs to have better accessibility
	const divSentinelStart = document.querySelector('div[data-testid="sentinelStart"]') as HTMLElement;
	const divSentinelEnd = document.querySelector('div[data-testid="sentinelEnd"]') as HTMLElement;
	divSentinelStart?.remove();
	divSentinelEnd?.remove();
	
	return (
		<StyledGeneralDialog
			id="customized-dialog"
			className={`${classname} general-dialog`}
			open={isOpen}
			onClose={handleClose}
			aria-labelledby="general-dialog-title"
			fullWidth={fullWidth}
			maxWidth={maxWidth}
			hideBackdrop={false}
			disableBackdropClick={disableBackdropClick}
			commonStyles={commonStyles}
			isMarketPlaceContent={isMarketPlaceContent}
			tabIndex={0}
			PaperProps={{
				tabIndex: 0
			}}
		>
			{title && (
				<StyledDialogTitle
					id="general-dialog-title"
					isHeaderBackgroundDefault={headerBackgroundDefault}
					justifyContentTitle={justifyContentTitle}
					isHeaderDefault={headerDefault}
				>
					<div className="title-wrapper">
						{isMarketPlaceContent ? (
						  <Typography variant="h5">{title}</Typography>
						) : (
						  <div className="title">{title}</div>
						)}
						{!hideCloseIcon && (
							<IconButton aria-label="close" title="close" className="button-close" onClick={handleClose} id="btn-generaldialog-close" >
								<Close />
							</IconButton>
						)}
					</div>
				</StyledDialogTitle>)}
			<DialogContent>
				<div className="general-dialog-content">
					{content}
				</div>
			</DialogContent>
			<StyledDialogActions justifyContentAction={justifyContentAction} commonStyles={actionStyles} isMarketPlaceContent={isMarketPlaceContent}>
				{!hideButtonCancel && (
					isMarketPlaceContent ? 
					(
					 <Button variant='outlined' size="medium" onClick={handleClose} id="btn-generaldialog-cancel">{cancelLabel}</Button>
					) : 
					(
					 <HlxButton variant='outlined' label={cancelLabel} onClick={handleClose} id="btn-generaldialog-cancel" />
					)
				)}
				{buttonSubmit}
			</StyledDialogActions>
		</StyledGeneralDialog>
	);
};

generalDialog.defaultProps = {
    isOpen: true,
    headerDefault: true,
    headerBackgroundDefault: true,
    deviders: true,
    hideButtonCancel: false,
    disableBackdropClick: false,
    classname: '',
    fullWidth: true,
    maxWidth: 'sm',
    title: 'Confirmation',
    content: 'Content Dialog',
    cancelLabel: 'CANCEL',
    buttonSubmit: <HlxButton label="OK" />,
	isMarketPlaceContent: false
};

export default React.memo(generalDialog);
